import { Paginated, RequestedFeature } from "@vixi/types";
import { useMutation, useMutationState, useQueryClient } from "@tanstack/react-query";
import { optimisticDownvote, optimisticUpvote } from "./optimisticVote";
import { requestedFeaturesQueryOptions } from "@/queries/featureRequests/requestedFeaturesQuery";
import { debouncedVote } from "@/utils/debouncedVote";

export const useUpvoteFeature = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: ["upvote-feature"],
    mutationFn: async (featureId: RequestedFeature["id"]) => {
      // Optimistically update the cache
      queryClient.setQueryData<Paginated<RequestedFeature>>(
        requestedFeaturesQueryOptions().queryKey,
        optimisticUpvote(featureId),
      );

      try {
        const response = await debouncedVote(featureId, true);
        return response.data;
      } catch (error) {
        queryClient.setQueryData<Paginated<RequestedFeature>>(
          requestedFeaturesQueryOptions().queryKey,
          optimisticDownvote(featureId),
        );
      }
    },
  });

  return mutation;
};

export const useUpvoteFeatureState = () => {
  return useMutationState({
    filters: { mutationKey: ["upvote-feature"], status: "pending" },
  });
};
